<script lang="ts" setup>
const { chosenPlace, places } = usePlaces()

const props = defineProps<{
  light?: boolean
}>()
</script>

<template>
  <div
    class="flex w-fit flex-col justify-center gap-5 rounded-3xl bg-neutral-500 p-5 px-10 text-center"
    :class="{
      'text-white': !props.light,
      'bg-white text-neutral-700': props.light,
    }"
  >
    <div class="mb-5 flex flex-wrap gap-5">
      <button
        class="rounded-full px-8 py-2 text-sm font-semibold"
        :class="{
          'bg-red-600 text-white': chosenPlace === place.name,
          'bg-white text-neutral-700':
            chosenPlace !== place.name && !props.light,
          'bg-neutral-700 text-white':
            chosenPlace !== place.name && props.light,
        }"
        v-for="place in places"
        @click="chosenPlace = place.name"
      >
        {{ place.name }}
      </button>
    </div>
    <div class="flex gap-5 max-sm:flex-col">
      <template v-for="place in places">
        <div v-if="place.name === chosenPlace">
          <address
            class="flex flex-col items-start gap-2 text-left font-bold not-italic"
          >
            <p>{{ place.address }}</p>
            <p class="mb-10">{{ place.city }}</p>
            <p>info@grapesc.cz</p>
            <NuxtLink :href="place.tel">
              <button
                class="flex items-center gap-2 rounded-full bg-sky-600 px-4 py-2 text-sm font-medium text-white"
              >
                <Icon name="fa6-solid:phone" />
                {{ place.phone }}
              </button>
            </NuxtLink>
          </address>
        </div>
      </template>
      <div class="grid grid-cols-3 place-items-start gap-x-5">
        <p>Pondělí</p>
        <p>7:30 - 12:00</p>
        <p>13:00 - 15:30</p>
        <p>Úterý</p>
        <p>7:30 - 12:00</p>
        <p>13:00 - 15:30</p>
        <p>Středa</p>
        <p>7:30 - 12:00</p>
        <p>13:00 - 17:00</p>
        <p>Čtvrtek</p>
        <p>7:30 - 12:00</p>
        <p>13:00 - 15:30</p>
        <p>Pátek</p>
        <p>na objednání</p>
      </div>
    </div>
  </div>
</template>
